// src/ThemeContext.js
import React from 'react';

export const intialContext = {
    isHook: true
}

export const MedyconContext = React.createContext(intialContext);